const configuredBaseUrl = process.env.REACT_APP_WEBSITE_API_BASE_URL || ""
const apiBaseUrl = configuredBaseUrl || "/api"

async function parseError(response) {
  try {
    const payload = await response.json()
    if (payload && typeof payload.detail === "string" && payload.detail.trim()) return payload.detail
  } catch {}
  return `Request failed (${response.status})`
}

async function fetchWithFallback(path, init) {
  const url = `${apiBaseUrl}${path.startsWith("/") ? path : "/" + path}`
  return fetch(url, init)
}

export async function websiteJson(path, { method = "GET", body = null, token = "" } = {}) {
  const headers = {}
  if (body) headers["Content-Type"] = "application/json"
  if (token) headers.Authorization = `Bearer ${token}`
  const response = await fetchWithFallback(path, { method, headers, body: body ? JSON.stringify(body) : undefined })
  if (!response.ok) throw new Error(await parseError(response))
  if (response.status === 204) return null
  return response.json()
}

export async function websiteBlob(path, { token = "" } = {}) {
  const headers = {}
  if (token) headers.Authorization = `Bearer ${token}`
  const response = await fetchWithFallback(path, { headers })
  if (!response.ok) throw new Error(await parseError(response))
  return { blob: await response.blob(), filenameHeader: response.headers.get("content-disposition") || "" }
}
